import { createAction } from '@reduxjs/toolkit'

// if an action is only used to update state in a single slice, it should be defined in that slice
// if an action is used to update state in multiple slices, it should be defined here
// this prevents potential circular dependency issues (more info: https://redux-toolkit.js.org/usage/usage-guide#exporting-and-using-slices)

// pdf
export const addPdf = createAction('pdf/addPdf')
export const resetPdf = createAction('pdf/resetPdf')
export const replacePdf = createAction('pdf/replacePdf')
// pages + layouts
export const initializePdfPages = createAction('pdf/initializePdfPages')
export const backFillPagesAndLayouts = createAction('pdf/backFillPagesAndLayouts')
// elements
export const createElement = createAction('elements/createElement')
export const updateElement = createAction('elements/updateElement')
export const deleteElement = createAction('elements/deleteElement')
export const selectElement = createAction('elements/selectElement')

export const createTable = createAction('elements/createTable')
export const moveTable = createAction('elements/moveTable')
export const resizeTable = createAction('elements/resizeTable')
export const deleteTable = createAction('elements/deleteTable')
